import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import NexWordmark from "@/components/NexWordmark";
import {
  ArrowLeft, LayoutDashboard, Receipt, ShieldCheck, PieChart, TrendingUp, FileText, LogOut, Landmark,
} from "lucide-react";

export const fmtUsd = (v) => {
  const n = Number(v || 0);
  const sign = n < 0 ? "-" : "";
  return `${sign}$${Math.abs(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const NAV = [
  { to: "/admin/finance",              label: "Overview",       Icon: LayoutDashboard },
  { to: "/admin/finance/transactions", label: "Transactions",   Icon: Receipt },
  { to: "/admin/finance/bills",        label: "Bills",          Icon: Landmark },
  { to: "/admin/finance/expenses",     label: "Expenses",       Icon: ShieldCheck },
  { to: "/admin/finance/distributions",label: "Distributions",  Icon: PieChart },
  { to: "/admin/finance/forecast",     label: "Forecast",       Icon: TrendingUp },
  { to: "/admin/finance/reports",      label: "Reports",        Icon: FileText },
];

const FinanceLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#0B0F19]">
      <div className="border-b border-nex-border bg-black/40 backdrop-blur">
        <div className="w-full mx-auto px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32 py-4 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <Link to="/admin" className="flex items-center gap-3">
            <ArrowLeft size={14} className="text-nex-chrome" />
            <NexWordmark size="text-xl" />
            <span className="mono-body text-[10px] tracking-[0.25em] uppercase text-nex-gold hidden md:inline">// Finance</span>
          </Link>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            {NAV.map(({ to, label, Icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/admin/finance"}
                data-testid={`nav-finance-${label.toLowerCase()}`}
                className={({ isActive }) =>
                  `mono-body text-[11px] uppercase tracking-[0.2em] whitespace-nowrap ${isActive ? "text-nex-gold" : "text-nex-chrome hover:text-nex-silver"}`
                }
              >
                <Icon size={12} className="inline mr-1" /> {label}
              </NavLink>
            ))}
            <span className="mono-body text-[11px] text-nex-chrome hidden md:inline">
              {user?.email}
              {user?.is_partner && <span className="ml-2 text-nex-gold">· PARTNER</span>}
            </span>
            <button
              onClick={() => { logout(); nav("/admin/login"); }}
              data-testid="logout-btn"
              className="tick-btn-secondary text-xs !py-2 !px-3"
            >
              <LogOut size={13} /> Sign Out
            </button>
          </div>
        </div>
      </div>
      <div className="w-full mx-auto px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32 py-8">{children}</div>
    </div>
  );
};

export default FinanceLayout;
